import api from './api';
import type {
  Candle,
  Timeframe,
  AnalysisMethodology,
  AIModel,
  PaginatedResponse,
} from '@trading/shared';
import type { StoredAnalysisPayload } from '../store/analysisStore';

interface AnalysisRequest {
  symbol: string;
  timeframe: Timeframe;
  methodology: AnalysisMethodology;
  aiModel: AIModel;
  candles: Candle[];
  /** Optional user-defined prompt addendum (Pro+ only). */
  userPromptId?: string;
}

export const analysisService = {
  async create(request: AnalysisRequest): Promise<{ id: string; status: string }> {
    const response = await api.post<{ id: string; status: string }>('/analysis', request);
    return response.data;
  },

  async getById(id: string): Promise<StoredAnalysisPayload> {
    const response = await api.get<StoredAnalysisPayload>(`/analysis/${id}`);
    return response.data;
  },

  async getHistory(page = 1, limit = 20, excludeNoSetup = false): Promise<PaginatedResponse<StoredAnalysisPayload>> {
    const response = await api.get<PaginatedResponse<StoredAnalysisPayload>>(
      '/analysis/history',
      { params: { page, limit, ...(excludeNoSetup && { excludeNoSetup: 'true' }) } }
    );
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/analysis/${id}`);
  },
};
